// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3F44s","notes":"Notes_notes__1cSI8"};